import { HttpErrorResponse } from '@angular/common/http';
import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';
import { AppState } from '../../app.state';

import { Patient } from '../../shared/models/patient.model';

import * as reasonsActions from './reasons.actions';

export interface State {
  readonly current: any;
  readonly list: any[];
  readonly selectedPatients: Patient[];
}

const initialState: State = {
  current: null,
  list: [],
  selectedPatients: [],
};

export function reasonsReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case reasonsActions.actionTypes.SET_CURRENT_REASON:
      return {
        ...state,
        current: action.payload,
      };

    case reasonsActions.actionTypes.UNSET_CURRENT_REASON:
      return {
        ...state,
        current: null,
      };

    case reasonsActions.actionTypes.UPDATE_REASON_PREFERENCE:
      return {
        ...state,
        current: {
          ...state.current,
          preferences: action.payload,
        },
      };

    case reasonsActions.actionTypes.UPDATE_REASON_VISIT_CHOICE:
      return {
        ...state,
        current: {
          ...state.current,
          selectedVisitReason: action.payload,
        },
      };

    case reasonsActions.actionTypes.UPDATE_REASON_PREFERRED_DATE:
      return {
        ...state,
        current: {
          ...state.current,
          preferredDate: action.payload,
        },
      };

    case reasonsActions.actionTypes.UPDATE_REASON_START_DATE:
      return {
        ...state,
        current: {
          ...state.current,
          startDate: action.payload,
        },
      };

    case reasonsActions.actionTypes.UPDATE_ELIGIBLE_ACCOUNTS_IDS:
      return {
        ...state,
        current: {
          ...state.current,
          eligibleAccountsIds: action.payload,
        },
      };

    case reasonsActions.actionTypes.UPDATE_CONSECUTIVE_DELAY:
      return {
        ...state,
        current: {
          ...state.current,
          consecutiveDelay: action.payload,
        },
      };

    case reasonsActions.actionTypes.ADD_REASONS:
      return {
        ...state,
        list: [
          ...state.list,
          ...action.payload,
        ],
      };

    case reasonsActions.actionTypes.REMOVE_REASONS:
      const reasonsIds = action.payload ? action.payload.map(reason => reason.id) : [];

      return {
        ...state,
        list: state.list.filter(reason => !reasonsIds.find(reasonId => reasonId === reason.id)),
      };

    case reasonsActions.actionTypes.SET_REASONS:
      return {
        ...state,
        list: action.payload,
      };

    case reasonsActions.actionTypes.RESET_REASONS:
      return {
        ...state,
        list: [],
      };

    case reasonsActions.actionTypes.SET_SELECTED_PATIENTS:
      return {
        ...state,
        selectedPatients: action.payload,
      };

    case reasonsActions.actionTypes.RESET_SELECTED_PATIENTS:
      return {
        ...state,
        selectedPatients: [],
      };

    default:
      return state;
  }
}

export const getReasonsState = (state: AppState) => state.reasons;
export const getSelectedPatients = createSelector(getReasonsState, (state: State): Patient[] => state.selectedPatients);



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reasons.reducer.ts